module.exports = __webpack_public_path__ + "static/media/emily_rda.380e6506.png";